document.addEventListener('DOMContentLoaded', function() {
    // Select the legend element
    const legend = document.querySelector('fieldset.product-variant-picker-block legend');
    
    // Function to update the legend text
    function updateLegend() {
        const selectedOption = document.querySelector('input[name="options[Size]"]:checked');
        if (selectedOption) {
            legend.textContent = 'Size: ' + selectedOption.value;
        }
    }

    // Add change event listeners to all radio buttons
    const radioButtons = document.querySelectorAll('input[name="options[Size]"]');
    radioButtons.forEach(radio => {
        radio.addEventListener('change', updateLegend);
    });

    // Call updateLegend on page load to set the initial value
    updateLegend();
});

document.addEventListener("DOMContentLoaded", function () {
  // size guide on product page js

  const sizeGuide = document.querySelector(".custom--size-guide");
  const sizeGuideChart = document.querySelector(".custom--size-guide-chart");
  const sizeGuideChartClose = document.querySelector(
    ".custom--size-guide-chart-close"
  );
  const sizeGuideLabel = document.querySelector(".custom--size-guide-label");

  if (
    sizeGuideLabel &&
    sizeGuideChart &&
    sizeGuideChartClose &&
    sizeGuideLabel
  ) {
    sizeGuideLabel.addEventListener("click", function () {
      sizeGuideChart.classList.add("active");
      document.querySelector("body").style.overflow = "hidden";
    });

    sizeGuideChartClose.addEventListener("click", function (event) {
      event.stopPropagation();
      closeModal();
    });

    // Close modal when clicking outside of the chart
    sizeGuideChart.addEventListener("click", function (event) {
      // Check if the click target is the chart itself (the background)
      if (event.target === sizeGuideChart) {
        closeModal();
      }
    });

    function closeModal() {
      sizeGuideChart.classList.remove("active");
      document.querySelector("body").style.overflow = "visible";
    }
  }
});
